import { createContext } from 'react';
import type { FeatureFlagKey } from '../../types/featureFlags';

/** "loading" only until the first answer for the signed-in user; a refresh keeps the last list. */
export type FeatureFlagsStatus = 'loading' | 'ready';

export interface FeatureFlagsContextValue {
  status: FeatureFlagsStatus;
  /** Whether the flag is on for this user. False while loading, on any error, and outside a provider. */
  isEnabled: (key: FeatureFlagKey) => boolean;
  /** Loads the list again, keeping the current one until the answer lands. Never rejects. */
  refresh: () => Promise<void>;
  /** Goes up each time a load or refresh lands. Lets code that reads its own flag list re-read it. */
  revision: number;
}

/**
 * Outside a `FeatureFlagsProvider` every flag reads as off. Failing closed is the whole point of a
 * dark launch: a missing provider must hide a feature, never show it.
 */
export const FeatureFlagsContext = createContext<FeatureFlagsContextValue>({
  status: 'ready',
  isEnabled: () => false,
  refresh: () => Promise.resolve(),
  revision: 0,
});
